// extracted by mini-css-extract-plugin
module.exports = {"fiveGViewRoot":"fivegworldview_fiveGViewRoot__1GfhM","headerSection":"fivegworldview_headerSection__2RLjv","contentSection":"fivegworldview_contentSection__3ECrz"};